import CasPage, { ICasPage } from 'src/compass/shared/components/CasPage/CasPage';
import CurrentPeriodDisplay from './CurrentPeriodDisplay';

export default function CasPeriodPage(props: ICasPage) {
  return <CasPage {...props} titleSuffix={<CurrentPeriodDisplay />} />;
}
